import moment from "moment";
export default class InstructorTableKidSchool {
    hourFrom;
    minuteFrom;
    duration;
    pricePerKid;
    instructorMaxCount;
    capacity;
    kids;
    finalKidCount;
    id;
    instructorIds = [];
    isPremium;
    leaderId;
    isPrepaidOnly;
    get kidCount() {
        return this.finalKidCount ? this.finalKidCount : this.kids.length;
    }
    get hourTo() {
        return moment().set({ hour: this.hourFrom, minute: this.minuteFrom }).add(this.duration, 'minutes').hour();
    }
    get minuteTo() {
        return moment().set({ hour: this.hourFrom, minute: this.minuteFrom }).add(this.duration, 'minutes').minute();
    }
}
